import SendbirdChat from '@sendbird/chat'
import { GroupChannelModule } from '@sendbird/chat/groupChannel'

export const initSendbirdInstance = (appId) => {
  const params = {
    appId: appId,
    modules: [new GroupChannelModule()],
  }
  return SendbirdChat.init(params)
}
